import { closeAll } from "../utils/accordion";
import { $Q, $Qll } from "../utils/query-selector"
import { dataToggle } from "../utils/toggle-dataset";
import { hiddenWidgets } from "./cart";

/**
 * DropDown Action - if is not data active true
 * @param {HTMLElement} element - Node to change data active
 */

 function dropDownAction(element, event) {
  // eslint-disable-next-line no-unused-expressions
  closeAll('.nav-item-js', $Q('#nav-list-movil-js'), element);

  // mouseleave event only work if dataset.active is false
  if (event === 'mouseleave' && element.dataset.active === 'false') return;

  dataToggle(element);
}

/**
 * Event dropDown
 * @param {HTMLElement} node - Event target node
 * @param {EventListener} event - Type event
 * @param {HTMLElement} nodeOnAction - Node to change data active
 * @returns Function Event
 */
 function eventDropDown(
  node,
  event,
  nodeOnAction,
) {
  return node.addEventListener(event, () => {
    dropDownAction(nodeOnAction, event)
  })
}

/**
 * Open dropdown menu - click / mouseentre event
 * To select type event check data-event in node#nav-list-js
 */
export function openDropDown() {
  if (!$Q('#nav-list-js')) return;
  const { dataset } = $Q('#nav-list-js');

  // eslint-disable-next-line no-undef
  if (dataset.event === 'click' || innerWidth < 1100) {
    $Qll('.button-dropdown-js')
      .forEach((item) => (

        eventDropDown(item, 'click', item)
      ))
  } else {
    window.addEventListener('load', () => {
      $Qll('.nav-item-js')
        .forEach((item) => {
          eventDropDown(item, 'mouseenter', item.children[0])
          eventDropDown(item, 'mouseleave', item.children[0])
        })
    })
  }
}

function initialPosition(node, scrollTop) {
  if (scrollTop === 0) {
    if (node.classList.contains('sticky-header')) node.classList.remove('sticky-header')
  } else if (!node.classList.contains('sticky-header')) node.classList.add('sticky-header')
}

/**
 * Add sticky css class if the scroll is going down or up
 * @param {node} node - Element to apply sticky class
 * @param {number} positionScroll - Number that indicate scroll position
 * @see stickyUp
 * @returns null - stop called
 * @author Daniel Santos
 */
function stickyToggleCssClass(node, positionScroll) {
  const scrollTop = document.body.getBoundingClientRect().top

  initialPosition(node, scrollTop)

  if (scrollTop > -100) {
    if (node.classList.contains('down')) node.classList.remove('down')

    return
  }

  if (scrollTop < positionScroll) {
    if (!node.classList.contains('down')
    && !node.classList.contains('isOpenMobile')) node.classList.add('down')

    return scrollTop
  }

  if (node.classList.contains('down')) node.classList.remove('down')

  return scrollTop
}

/**
 * Listen to scroll and call stickyToggleCssClass
 * @param {node} node - Element to apply sticky class
 * @see stickyToggleCssClass
 * @returns null - stop called
 * @author Daniel Santos
 */
export function stickyUp(node) {
  const element = $Q(node)

  if (!element) return;

  let positionScroll = 0

  window.addEventListener('scroll', () => {
    positionScroll = stickyToggleCssClass(element, positionScroll)
  }, { passive: true })
}

/**
 * Custom data toggle for header in mobile
 * Just work in home or index template
 * @author Daniel Santos
 */
export function headerDataToggleMobile() {
  const header = $Q('.js-header')

  $Qll('.burger-nav-js').forEach((nav) => {
    nav.addEventListener('click', () => {
      const state = dataToggle($Q('#nav-list-movil-js'), true, true);
      hiddenWidgets(state)

      if (state && !header.classList.contains('isOpenMobile')) {
        header.classList.add('isOpenMobile')
      } else {
        header.classList.remove('isOpenMobile')
      }
    });
  })
}
